// Pure helpers for MCO supplement Add Plan — no API / MCOService imports (selfcheck-safe).

/** Same coverage ladder as OptimizeInsuranceDialog setup step. */
export const MCO_UNDERLYING_COVERAGE_LEVELS = [0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85];

/**
 * Adapter: MCO plan → endorsements grid combo row (presentation only).
 * Underlying MPCI is not saved — only on sale for MCO at early SCD.
 */
export function mcoSupplementOptionToGridRow({ mcoPlan, acres, underlyingIntentLabel }) {
  const mcoPremiumPerAcre = Number(mcoPlan.producer_premium_amount_per_acre) || 0;
  return {
    premium_cost_total_per_acre: mcoPremiumPerAcre,
    breakeven_projected: null,
    loss_amount_maximum_per_acre: 0,
    underlyingIntentLabel,
    comboStressTestResults: {
      insurancePlans: [
        {
          insurance_plan_name: mcoPlan.insurance_plan_name,
          coverage_level_percent: mcoPlan.coverage_level_percent,
          insurancePlanParameters: mcoPlan,
        },
      ],
    },
    _savePlans: [mcoPlan],
    _acres: acres,
  };
}
